// API 基础配置 - 更改后端地址只需修改此文件
//export const BASE_URL = 'https://www.myhousekeeper.cn';
export const BASE_URL = 'https://www.dproot.cn';

export const API_URL = `${BASE_URL}/api/housekeepers`;
export const AUTH_API_URL = `${BASE_URL}/api/auth`;
export const COS_API_URL = `${BASE_URL}/api/cos`;
